import { LinearProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useKeycloak } from '@react-keycloak/web';
import PropTypes from 'prop-types';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppLayout from '../AppLayout';
import Router from '../Router';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: `env(safe-area-inset-bottom)`
  },
  container: {
    padding: 0
  },
  imgContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0
    },
    display: 'flex',
    justifyContent: 'center'
  },
  img: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain'
  },
  toolbar: {
    paddingRight: 24 // keep right padding when drawer closed
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  title: {
    flexGrow: 1,
    marginLeft: 12,
    marginRight: 36
  },
  content: {
    flexGrow: 1,
    // padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: 0
    },
    height: '100%',
    overflow: 'auto'
  },
  chartContainer: {
    marginLeft: -22
  },
  tableContainer: {
    height: 320
  },
  h5: {
    marginBottom: theme.spacing(2)
  }
});

const MainApp = () => {
  const [keycloak, initialized] = useKeycloak();

  if (!initialized) {
    return <LinearProgress />;
  }
  if (keycloak && !keycloak.authenticated) {
    localStorage.removeItem('menus');
    console.log('login');
    keycloak.login();
    return <LinearProgress />;
  }

  return (
    <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE || ''}>
      <AppLayout>
        <Router />
      </AppLayout>
    </BrowserRouter>
  );
};

MainApp.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MainApp);
